/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Help_Center__Payments_N_Refunds__Answer_2Inputs */

const en_help_center__payments_n_refunds__answer_2 = /** @type {(inputs: Help_Center__Payments_N_Refunds__Answer_2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Entry prices are refundable only if the battle doesn't start (doesn't fill up) or if BidBattles cancels the battle. Once a battle goes live, entry prices are non-refundable as you've committed to participating in the auction. See our full Refund Policy above for details.`)
};

/**
* | output |
* | --- |
* | "Entry prices are refundable only if the battle doesn't start (doesn't fill up) or if BidBattles cancels the battle. Once a battle goes live, entry prices are..." |
*
* @param {Help_Center__Payments_N_Refunds__Answer_2Inputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const help_center__payments_n_refunds__answer_2 = /** @type {((inputs?: Help_Center__Payments_N_Refunds__Answer_2Inputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Help_Center__Payments_N_Refunds__Answer_2Inputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_help_center__payments_n_refunds__answer_2(inputs)
});